













































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { EAlignFieldType } from '../context-menu/types/enums/align-field-type';
import { IField } from '@/dealroom/fields/types/field';
import { EFieldType } from '@/dealroom/fields/types/enums/field-type';
import { IFieldMenuAction } from '@/dealroom/fields/context-menu/types/field-menu-action';
import FieldContainer from '@/dealroom/fields/components/FieldContainer.vue';
import FieldContextMenu from '@/dealroom/fields/context-menu/components/FieldContextMenu.vue';
import TextField from '@/dealroom/fields/text-field/components/TextField.vue';
import Initials from '@/dealroom/fields/initials-field/components/Initials.vue';
import SignatureField from '@/dealroom/fields/signature-field/components/SignatureField.vue';
import LinkField from '@/dealroom/fields/link-field/components/LinkField.vue';
import DropdownField from '@/dealroom/fields/dropdown-field/components/DropdownField.vue';
import FormattedField from '@/dealroom/fields/formatted-field/components/FormattedField.vue';
import MergeField from '@/dealroom/fields/merge-field/components/MergeField.vue';
import CheckboxField from '@/dealroom/fields/checkbox-field/components/CheckboxField.vue';
import InitialsField from '@/dealroom/fields/initials-field/components/InitialsField.vue';
import Icon from '@/components/Icon.vue';
import { IRecipient } from '@/types/Recipient';
import { IUser } from '@/types/User';
import { IDocumentPage } from '@/types/document-page';
import { IMergeFieldMapObject } from '@/dealroom/fields/merge-field/types/merge-field-map-object';
import { fieldTextSizes } from '@/dealroom/fields/context-menu/constants/field-text-sizes';
import { EnumDocumentType } from '@/enums/DocumentType';
import FieldTooltip from '@/dealroom/fields/components/FieldTooltip.vue';
import { ContextMenuHelper } from '@/dealroom/fields/context-menu/helpers/context-menu.helper';
import { FieldHelper } from '@/dealroom/fields/helpers/field.helper';
import { EBreakpoint } from '@/enums/breakpoint';
import { EFieldSource } from '@/api/fields/types/field-source';

@Component({
  components: {
    FieldContainer,
    TextField,
    Initials,
    FieldContextMenu,
    SignatureField,
    MergeField,
    LinkField,
    DropdownField,
    FormattedField,
    CheckboxField,
    InitialsField,
    Icon,
    FieldTooltip,
  },
  data: () => ({
    EFieldType,
  }),
})
export default class Field extends Vue {
  @Prop() field!: IField;
  @Prop() sender!: IUser;

  @Prop() recipients: IRecipient[];
  @Prop() fullName: string;
  @Prop() pages: IDocumentPage[];
  @Prop() pageWidth: number;
  @Prop() multiSelectMode: boolean;
  @Prop() hideMenu: boolean;
  @Prop() showMenuOnDefault: boolean;
  @Prop() documentType: EnumDocumentType;
  @Prop() focused: boolean;
  @Prop() isContextMenuOpen: boolean;

  @Prop({ default: true }) resizable: boolean;
  @Prop({ default: true }) parent: boolean;
  @Prop({ default: false }) inSelectBox: boolean;
  @Prop() mergeFieldMapObject?: IMergeFieldMapObject;
  @Prop({ default: () => [] }) selectedFieldIds?: string[];

  menuOpen = false;
  fieldTextSizes: number[] = fieldTextSizes;
  textSize: number = this.displayedTextSize;
  fieldHover = false;
  fieldHeight: number = this.field.position.height;
  invalid = false;
  showTooltip = false;

  get showContextMenu(): boolean {
    return this.lastSelected && this.menuOpen && !this.hideMenu;
  }

  get showOpenMenuButton(): boolean {
    return !this.menuOpen && !this.hideMenu && this.fieldActions && !!this.fieldActions.length;
  }

  get errorMessage(): string {
    if (this.invalid) {
      return this.field.validationWarning || this.$t('invalid-input').toString();
    }
    return !this.validatedInput
      ? this.$t(FieldHelper.getValidatedErrorMessage(this.field.type)).toString()
      : this.$t(FieldHelper.getRequiredErrorMessage(this.field.type)).toString();
  }

  get validatedInput(): boolean {
    return FieldHelper.getValidatedInput(this.field);
  }

  get isTemplate(): boolean {
    return this.documentType === EnumDocumentType.Template;
  }

  get hasError(): boolean {
    if (this.invalid) {
      return true;
    }
    if (this.isTemplate) {
      return false;
    }
    if (this.validatedInput && this.requiredSenderFieldHasValue) {
      return false;
    }
    return true;
  }

  get requiredSenderFieldHasValue(): boolean {
    if (this.field.isRequired && this.field.source === EFieldSource.Sender) {
      return !!this.field.value;
    }
    return true;
  }

  get scaleInitials(): boolean {
    return this.fieldHeight < FieldHelper.defaultHeight(this.field.type);
  }

  get flipped(): boolean {
    const marginRight: number =
      this.pageWidth - this.field.position.left - this.field.position.width;
    const isSmallWindow: boolean = window.innerWidth <= EBreakpoint.Medium;
    return marginRight < 210 && isSmallWindow;
  }

  get locked(): boolean {
    return (
      this.selectedFieldIds.length > 1 ||
      this.menuOpen ||
      this.multiSelectMode ||
      !this.isFieldEditable
    );
  }

  get isRequired(): boolean {
    return this.field.isRequired && !this.field.value;
  }

  get deactivationDisabled(): boolean {
    return this.multiSelectMode || this.selectedFieldIds.length > 1 || this.menuOpen;
  }

  get isSelected(): boolean {
    return this.selectedFieldIds.some((id: string) => id === this.field.id);
  }

  get onlySelected(): boolean {
    if (this.selectedFieldIds.length === 0 || this.inSelectBox) {
      return false;
    }
    return this.selectedFieldIds.length === 1 && this.field.id === this.selectedFieldIds[0];
  }

  get lastSelected(): boolean {
    if (this.selectedFieldIds.length === 0) {
      return false;
    }
    return this.selectedFieldIds[this.selectedFieldIds.length - 1] === this.field.id;
  }

  get isSender() {
    return this.field.source === EFieldSource.Sender;
  }

  get displayedTextSize(): number {
    return FieldHelper.getTextSize(this.field.position, this.pageWidth, fieldTextSizes);
  }

  get hasValidatedValue(): boolean {
    return FieldHelper.getValidatedInput(this.field);
  }

  get showInitials(): boolean {
    if (this.field.position.width < 50) {
      return false;
    }
    if (
      !this.fullName ||
      this.field.type === EFieldType.Initials ||
      this.field.type === EFieldType.Check
    ) {
      return false;
    }
    return true;
  }

  get isFieldEditable(): boolean {
    return this.isTemplate || this.field.isEditable;
  }

  get fieldActions(): IFieldMenuAction[] {
    return ContextMenuHelper.singleFieldActions(this.field, this.isTemplate);
  }

  get allowTooltip(): boolean {
    if (!this.hasError) {
      return false;
    }
    return !this.isContextMenuOpen && this.selectedFieldIds.length < 2;
  }

  handleIsHovered(showTooltip: boolean) {
    this.showTooltip = showTooltip;
  }

  handleOpenMenuClick() {
    if (!this.lastSelected) {
      this.handleActivate(this.field);
    }
    this.setMenuVisibility(true);
  }

  handleInvalidInput(isInvalid: boolean) {
    this.invalid = isInvalid;
  }

  handleDeselectAll() {
    this.setMenuVisibility(false);
    this.showTooltip = false;
    this.$emit('deselectAll');
  }

  handleAlign(actionType: EAlignFieldType) {
    this.$emit('align', actionType);
  }

  handleUpdateValue(value: string) {
    const updatedField: IField = { ...this.field, value };
    this.$emit('save', [updatedField]);
  }

  handleSave(field: IField) {
    this.$emit('save', [field]);
  }

  handleUpdate(payload: IField[]) {
    this.$emit('save', payload);
    this.handleDeselectAll();
  }

  handleDelete() {
    this.$emit('delete');
    this.setMenuVisibility(false);
  }

  handleMove(payload: string) {
    this.$emit('move', payload);
    this.setMenuVisibility(false);
  }

  handleDuplicate() {
    this.$emit('duplicate');
    this.setMenuVisibility(false);
  }

  handleTextSize(size: number) {
    this.textSize = size;
    this.$emit('textSize', FieldHelper.getSaveFieldHeight(size));
  }

  handleDeactivate(field: IField) {
    this.setMenuVisibility(false);
    this.$emit('deselect', field);
  }

  handleActivate(field: IField) {
    this.$emit('select', field);
  }

  setMenuVisibility(open: boolean) {
    this.menuOpen = open;
    if (open) {
      this.textSize = this.displayedTextSize;
    }
    this.$emit('openMenu', open);
  }

  handleKeyDown(event: KeyboardEvent) {
    if (this.isSelected && this.onlySelected && event.key === 'Escape') {
      if (this.menuOpen) {
        this.setMenuVisibility(false);
      } else {
        this.handleDeselectAll();
      }
    }
  }

  handleResizing(height: number) {
    this.fieldHeight = height;
  }

  mounted() {
    if (this.showMenuOnDefault) {
      this.setMenuVisibility(true);
    }
    document.addEventListener('keydown', this.handleKeyDown);
  }

  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }
}
